<template>
  <div style="margin-top: -20px">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vx-card>
            <div class="vx-row">
              <div
                class="
                  vx-col
                  w-full
                  flex flex-col
                  sm:w-1/5
                  md:w-1/5
                  lg:w-1/5
                  xl:w-1/5
                  mb-2
                "
                style="min-width: 200px; width: 250px"
              >
                <v-select
                  :placeholder="$t('selectCategory')"
                  label="categoryName"
                  :closeOnSelect="true"
                  v-model="selectedCategories"
                  :options="categories"
                  :reduce="(selectedCategories) => selectedCategories.id"
                />
              </div>
              <div
                id="users"
                class="
                  col
                  w-full
                  flex flex-col
                  sm:w-1/5
                  md:w-1/5
                  lg:w-1/5
                  xl:w-1/5
                  mb-2
                "
                style="min-width: 200px; width: 250px"
              >
                <UserSelect @receiveData="veri"></UserSelect>
              </div>
              <div
                class="
                  vx-col
                  w-full
                  flex flex-col
                  sm:w-1/5
                  md:w-1/5
                  lg:w-1/5
                  xl:w-1/5
                  mb-2
                "
                style="min-width: 200px; width: 250px"
              >
                <vs-input
                  icon-pack="feather"
                  icon="icon-search"
                  :label-placeholder="$t('search')"
                  class="is-label-placeholder"
                  v-model="searchInput"
                  @keypress.enter="searchImages"
                />
              </div>
              <div
                class="
                  vx-col
                  w-full
                  flex flex-col
                  sm:w-1/5
                  md:w-1/5
                  lg:w-1/5
                  xl:w-1/5
                "
                style="max-width: 140px"
              >
                <vs-button @click="searchImages">{{ $t("search") }}</vs-button>
              </div>
              <div
                class="
                  vx-col
                  w-full
                  flex flex-col
                  sm:w-1/5
                  md:w-1/5
                  lg:w-1/5
                  xl:w-1/5
                "
                style="max-width: 200px; min-width: 150px"
              >
                <vs-button @click="selectPage(1, 'button')">{{
                  $t("bringAll")
                }}</vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-8">
      <div class="row">
        <div class="col-md-12 mb-4">
          <vs-pagination
            v-show="ImagesData.length != 0"
            :total="totalPage"
            :max="9"
            v-model="page"
            @change="selectPage"
          ></vs-pagination>
        </div>
      </div>
      <div class="row" v-if="ImagesData.length != 0">
        <div class="col-md-3" v-for="(item, index) in ImagesData" :key="index">
          <vx-card class="grid-view-item mb-base overflow-hidden">
            <template slot="no-body">
              <router-link
                class="
                  item-img-container
                  bg-white
                  h-64
                  flex
                  items-center
                  justify-center
                  mb-4
                  cursor-pointer
                "
                :to="{
                  name: 'Product Detail',
                  params: { id: item.id, name: item.name },
                }"
              >
                <img
                  v-if="item.productFiles.length > 0"
                  :src="
                    'https://api.360photoboxcloud.com/' +
                    item.productFiles[0].fileName
                  "
                  :alt="item.name"
                  class="grid-view-img px-2"
                />
              </router-link>
              <div class="item-details px-4">
                <div class="my-4">
                  <h5 class="truncate font-semibold mt-4 mb-1">
                    {{ item.name }}
                  </h5>
                  <p class="item-description truncate text-sm">
                    {{ item.productCode }}
                  </p>
                </div>
              </div>

              <div class="flex flex-wrap">
                <div
                  class="
                    item-view-primary-action-btn
                    p-3
                    flex flex-grow
                    items-center
                    justify-center
                    cursor-pointer
                  "
                  @click="areyousure(item.id)"
                >
                  <feather-icon icon="XIcon" svgClasses="h-4 w-4" />

                  <span class="text-sm font-semibold ml-2">{{
                    $t("delete")
                  }}</span>
                </div>

                <router-link
                  class="
                    item-view-secondary-action-btn
                    bg-primary
                    p-3
                    flex flex-grow
                    items-center
                    justify-center
                    text-white
                    cursor-pointer
                    text-decoration-none
                  "
                  :to="{
                    name: 'Product Detail',
                    params: { id: item.id, name: item.name },
                  }"
                >
                  <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />

                  <span class="text-sm font-semibold ml-2">{{
                    $t("detail")
                  }}</span>
                </router-link>
              </div>
            </template>
          </vx-card>
        </div>
      </div>
    </div>
    <vs-popup
      classContent="popup-example"
      :title="$t('areYouSureDelete')"
      :active.sync="popupActive"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center">
            <vs-button @click="eraseImage" color="danger">{{
              $t("yes")
            }}</vs-button>
            <vs-button @click="popupActive = false" style="margin-left: 75px">{{
              $t("no")
            }}</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/* eslint-disable */
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";
import UserSelect from "../../components/UserSelect";

export default {
  components: {
    UserSelect,
  },

  data() {
    return {
      selected: [],
      totalItems: 10,
      ImagesData: [],
      page: 1,
      totalPage: 0,
      searchInput: "",
      counter: 1,
      categories: [],
      selectedCategories: "",
      selectedName: "",
      popupActive: false,
      eraseId: "",
      // isTyping: false
    };
  },
  methods: {
    veri(value) {
      return (this.selectedName = value);
    },
    //Get Categories
    getCategories() {
      if (this.$store.state.role == "Admin") {
        let path = "/categories/GetListByPaging";
        http
          .post(path, {
            RequestPage: 1,
          })
          .then((response) => {
            response.data.forEach((element) => {
              this.categories.push({
                id: element.id,
                categoryName: element.categoryName,
              });
            });
          });
      }
      if (this.$store.state.role == "User") {
        let path = "/categories/getByUserId";
        http
          .post(path, {
            RequestPage: 1,
            UserId: parseInt(this.$store.state.userId),
          })
          .then((response) => {
            response.data.forEach((element) => {
              this.categories.push({
                id: element.id,
                categoryName: element.categoryName,
              });
            });
          });
      }
    },
    //Select Page && Get Images
    selectPage(page, button) {
      if (button == "button") this.selectedCategories = "";
      if (page == "") page = 1;
      this.counter = page;
      this.ImagesData = [];
      this.page = page;
      this.searchImages();
    },
    validationsUser() {
      if (this.$store.state.role == "User") {
        let obj;
        if (this.selectedCategories != "" && this.searchInput != "") {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            categoryid: this.selectedCategories,
            UserId: parseInt(this.$store.state.userId),
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        } else if (this.selectedCategories != "" && this.searchInput == "") {
          obj = {
            RequestPage: parseInt(this.page),
            categoryid: this.selectedCategories,
            UserId: parseInt(this.$store.state.userId),
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        } else {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            UserId: parseInt(this.$store.state.userId),
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        let path = "/products/getlist";
        return [obj, path];
      }
      if (this.$store.state.role == "Admin") {
        let obj;
        if (
          this.selectedCategories != "" &&
          this.searchInput != "" &&
          this.selectedName != ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            categoryid: this.selectedCategories,
            UserId: this.selectedName,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        if (
          this.selectedCategories != "" &&
          this.searchInput != "" &&
          this.selectedName == ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            categoryid: this.selectedCategories,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        if (
          this.selectedCategories != "" &&
          this.searchInput == "" &&
          this.selectedName != ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            categoryid: this.selectedCategories,
            UserId: this.selectedName,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        if (
          this.selectedCategories != "" &&
          this.searchInput == "" &&
          this.selectedName == ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            categoryid: this.selectedCategories,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        if (
          this.selectedCategories == "" &&
          this.searchInput != "" &&
          this.selectedName != ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            UserId: this.selectedName,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        if (
          this.selectedCategories == "" &&
          this.searchInput != "" &&
          this.selectedName == ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        if (
          this.selectedCategories == "" &&
          this.searchInput == "" &&
          this.selectedName != ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            UserId: this.selectedName,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        if (
          this.selectedCategories == "" &&
          this.searchInput == "" &&
          this.selectedName == ""
        ) {
          obj = {
            RequestPage: parseInt(this.page),
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        let path = "/products/getlist";
        return [obj, path];
      }
    },
    //Search Data
    async searchImages() {
      this.ImagesData = [];
      /* if (this.searchInput == "" && this.selectedCategories == "")
        return notify.warning(this.$t("fillBlanks"));*/
      let data = await this.validationsUser();
      let path = data[1];
      http.post(path, data[0]).then((response) => {
        if (response.data.length == 0) {
          notify.warning(this.$t("noMatch"));
        } else {
          this.ImagesData = response.data;
          this.totalPage = response.totalPage;
          this.page = response.currentPage;
        }
      });
    },

    //Remove Image
    eraseImage() {
      http
        .get(`/products/delete?productId=${this.eraseId}`)
        .then((response) => {
          notify.success(this.$t("removed"));

          this.popupActive = false;
          this.searchImages();
        });
    },
    areyousure(id) {
      this.eraseId = id;
      this.popupActive = true;
    },
  },
  created() {
    this.getCategories();
  },
};
</script>

<style scoped>
.vs-input {
  width: 100% !important;
  margin: 0px;
}
.orta {
  display: flex;
  justify-content: center;
}
.grid-view-item .grid-view-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  transition: 0.35s;
}

.grid-view-item:hover {
  transform: translateY(-5px);
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
}
</style>